import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const StatsCardSkeleton: React.FC = () => {
  return (
    <Card className="p-4 md:p-6">
      <div className="flex items-center gap-3">
        <div className="p-2 md:p-3 rounded-lg bg-muted">
          <Skeleton className="h-5 w-5 md:h-6 md:w-6" />
        </div>
        <div className="flex-1 space-y-2">
          <Skeleton className="h-8 md:h-9 w-16" />
          <Skeleton className="h-3 md:h-4 w-24" />
        </div>
      </div>
    </Card>
  );
};

